import type { FunctionComponent } from 'react';

import { RouterLink } from '@trello/router/router-link';

import styles from './Breadcrumbs.less';

interface BreadcrumbItem {
  title: string;
  href: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = ({ items }) => {
  const breadcrumbItems = items.map(({ title, href }, index) => (
    // eslint-disable-next-line @eslint-react/no-array-index-key -- FIXME
    <li key={index} className={styles.breadcrumbItem}>
      <RouterLink href={href}>{title}</RouterLink>
    </li>
  ));

  return <ul className={styles.breadcrumbsList}>{breadcrumbItems}</ul>;
};
